import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Welcometocompany from "./components/Welcometocompany";
import NormalUserLayout from "../layouts/NormalUserLayout/NormalUserLayout";

// Site stylesheets (assets/css/main.css + ConstructionHome.css) are imported by Header,
// which every page of the site renders.

function ConstructionHome() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
      mirror: false
    });
  }, []);

  return (
    <div className="ConstructionHome">
      <NormalUserLayout>
        <Header />
        <main className="main">
          <Hero />
          <Welcometocompany />
          <Services />
        </main>
        <Footer />
      </NormalUserLayout>
    </div>
  );
}

export default ConstructionHome;
